
import React, {Component} from "react";

import "./achievements-widget.css";


class AchievementsWidget extends Component {
    render () {
       
        return (
            <div className="achievements_widget">
               <div className='achievements_widget_title'>Achievements</div>
                <div className='achievements_gray_trophy_image_container'>
                    <img alt="achievements_image" className='acheivements_gray_trophy_image' src={require(`./achievements/grey_trophy.png`)}/> 
                </div>
               <div className='achievements_widget_coming_soon'>Coming Soon</div>
            </div>
        );
    }
}

export default AchievementsWidget;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/progress-map/widgets/achievements-widget.js